import styled from 'styled-components';
import { Image, Link, media, Button } from '@minerva-analytics/pantheon';
import { WHITE, BLUE, BODY_TEXT } from 'root/theme';
import NotificationIcon from 'components/NotificationIcon';
import Menu from 'components/Menu';

const PROFILE_IMAGE_BREAKPOINT = `450px`;

const HeaderContainer = styled.header`
  background: ${WHITE};
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 130;
  height: 90px;
  padding: 15px 0 15px 0;
  box-shadow: 0 2px 10px 0 rgba(0,0,0,0.10);
  user-select: none;
`;

const HeaderMenu = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 1024px;
  padding: 0 20px 0 2rem;
  align-items: center;
  margin: 0 auto;
  width: 100%;
  ${media.tablet`
    padding-left: 2rem;
  `}
`;

const HeaderLeft = styled.div`
  align-items: center;
`;

const HeaderRight = styled.div`
  display: inline-flex;
  align-items: center;
  max-width: 600px;
  max-height:55px;
  margin: 0px;

  @media (max-width: ${PROFILE_IMAGE_BREAKPOINT}) {
    width: 130px;
  }
  @media (max-width: 550px) { 
    justify-content: flex-end;
  }
`;

const SeeHowSmart = styled.p`
  vertical-align: middle;
  ${BODY_TEXT}
  color: ${BLUE};

  @media (max-width: 900px) {
    display:none;
  }
`;

const ProfileImage = styled(Image)`
  border-radius: 50%;
  cursor: pointer;
  height: 60px;
  width: 60px;
  margin-left: 15px;

  @media (max-width: 360px) {
    height: 45px;
    width: 45px;
    margin-left: 10px;
  }
`;

const SigninLink = styled(Link)`
  color: #FFFFFF;
  font-family: "Montserrat" Helvetica, sans-serif;
  font-weight: bold;
  line-height: 27px;
  text-align: right;
  text-decoration: none;
`;

const SigninButton = styled(Button)`
  margin: 0px 0px 0px 35px;
  background-color: ${BLUE};
  @media (max-width: 452px) {
    margin: 0;
    min-width: 190px;
    padding: .8rem 1rem;
    font-size: 1rem;
  }
`;

const StyledNotificationIcon = styled(NotificationIcon)`
  padding: 1rem 0;
`;

const UserName = styled.div`
  color: ${BLUE};
  font-size: 24px;
  font-weight: bold;
`;

const DropdownMenu = styled(Menu)`
  width: 300px;
  right: 0px;
  top: 76px;

  @media (max-width: 1150px) {
    right: 6px;
  }

  @media (max-width: 768px) {
    top: 76px;
  }

  @media (max-width: 550px) {
    position: fixed;
    max-width: none;
    width: 100%;
    top: 90px;
    right: 0;
  }
`;

const MobileLogo = styled.img`
  width: 50px;
  display: none;
  ${media.extraSmall`
    display: block;
  `}
`;

const DesktopLogo = styled.div`
  width: 220px;
  ${media.extraSmall`
    display: none;
  `}
`;

export {
  HeaderContainer,
  HeaderMenu,
  HeaderLeft,
  HeaderRight,
  ProfileImage,
  SigninLink,
  SigninButton,
  StyledNotificationIcon,
  SeeHowSmart,
  UserName,
  DropdownMenu,
  MobileLogo,
  DesktopLogo,
};
